import { clsx } from 'clsx'
import { type FC } from 'react'

import { PrescriptionV3PrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { priceGetFormattedPercentageDiscount } from '../../../../price'
import { ProductDiscount } from '../../../../product'

type ProductDiscountBadgeProps = {
  className?: string
  currentPrescriptionType: PrescriptionV3PrescriptionTypeEnum
  'data-qa-id'?: string
  discount: number
  isDiscountValid: boolean
  isReferencePriceCommunication?: boolean
}

export const ProductDiscountBadge: FC<ProductDiscountBadgeProps> = ({
  className,
  currentPrescriptionType,
  'data-qa-id': dataQaId,
  discount,
  isDiscountValid,
  isReferencePriceCommunication = false,
}) => {
  if (
    currentPrescriptionType ===
    PrescriptionV3PrescriptionTypeEnum.NoPrescription
  ) {
    if (!discount || !isDiscountValid) {
      return null
    }

    return (
      <ProductDiscount
        className={clsx('text-xs', className)}
        data-qa-id={dataQaId}
      >
        {priceGetFormattedPercentageDiscount(discount)}
        {isReferencePriceCommunication ? '*' : null}
      </ProductDiscount>
    )
  }

  return null
}
